import { Component, JSX } from 'react';
import "./Styles.scss";
import { FileDropZone } from '../FileDropZone/FileDropZone';
import { Accept } from 'react-dropzone/.';
import { Guid } from '@iconics/core';
import { Button } from '../../Buttons/Button/Button';
import { Dialog } from '../../Dialogs/Dialog/Dialog';
import { DialogContent } from '../../Dialogs/Dialog/DialogContent';
import { DialogFooter } from '../../Dialogs/Dialog/DialogFooter';
import { ButtonBar } from '../../Buttons/ButtonBar/ButtonBar';
import { RightButtons } from '../../Buttons/ButtonBar/RightButtons';

export class MediaSelector extends Component<IMediaSelectorProps, IMediaSelectorState>
{
    public static selectButtonLabel = '';
    public static dialogTitle = '';
    public static duplicateImageError = '';
    public static selectedImageLabel = '';
    public static cancelButtonLabel = '';
    public static okButtonLabel = '';

    constructor(props: IMediaSelectorProps)
    {
        super(props);
        this.state =
        {
            show: false,
            focusedImage: { name: '', url: '' },
            selectedImage: { name: '', url: this.props.defaultSelectedImage ?? '' },
            selectedFile: { name: '', path: '' },
            showFileNameExistsError: false,
            resetFilesToken: Guid.new().toString(),
        };
    };

    public async componentDidUpdate(prevProps: IMediaSelectorProps, prevState: IMediaSelectorState): Promise<void>
    {
        if (prevProps.defaultSelectedImage != this.props.defaultSelectedImage)
        {
            this.setState({ selectedImage: { name: '', url: this.props.defaultSelectedImage ?? '' } })
        }
    }

    private imageSelected(image: IMediaSelectorImage): void
    {
        this.setState({ focusedImage: image });
    }

    private selectImage(): void
    {
        this.setState({ selectedImage: this.state.focusedImage, show: false });
        this.props.imageSelected(this.state.focusedImage);
    }

    private handleCancelModal(): void
    {

        this.setState({
            show: false,
            resetFilesToken: Guid.new().toString(),
        });
    }

    public render(): JSX.Element
    {
        const filteredOptions = this.props.options
        return (
            <div>
                {
                    !this.props.noPreview &&
                    <img
                        width={100}
                        height={100}
                        src={
                            this.state.selectedImage.url.length > 0 ?
                                this.getThumbnailImage(this.props.options.filter(x => x.url == this.state.selectedImage.url)[0]?.name.split('.').pop() ?? '', this.state.selectedImage.url) :
                                "/images/ImageSelectPlaceholder.svg"
                        }
                        alt="img-thumbnail"
                    />

                }
                {this.props.required && <span style={{ color: "red" }}>*</span>}
                <Button
                    style={{ marginTop: '15px' }}
                    onClick={() => this.setState({ show: true })}
                >
                    {this.props.selectButtonLabel ?? MediaSelector.selectButtonLabel}
                </Button>
                <Dialog
                    isOpen={this.state.show}
                    onOpenChange={() => this.handleCancelModal()}
                    title={this.props.dialogTitle ?? MediaSelector.dialogTitle}
                >
                    <DialogContent>
                        <FileDropZone
                            existingFileNames={this.props.options.map(x => x.name)}
                            uploadPath={this.props.uploadPath}
                            allowedFileTypes={this.props.allowedFileTypes}
                            onFilesUploaded={() => this.props.onFileUploaded()}
                            resetFilesToken={this.state.resetFilesToken}
                        />
                        {
                            this.state.showFileNameExistsError &&
                            <div className='media-selector-dialog__error-text'>
                                {this.props.duplicateImageError ?? MediaSelector.duplicateImageError}
                            </div>
                        }
                        <div className='media-selector-dialog__container'>
                            {
                                filteredOptions.length > 0 &&
                                filteredOptions.map(image =>
                                {
                                    return (
                                        <div
                                            key={image.name}
                                            style={{
                                                border: `${this.state.focusedImage.name == image.name ? '3px solid #4893CF' : ''}`,
                                                boxShadow: `${this.state.focusedImage.name == image.name ? '0px 4px 4px 0px #00000040' : ''}`,
                                                margin: '5px',
                                                height: '100px'
                                            }}
                                            onClick={() => this.imageSelected(image)}>
                                            <img width={100} height={100} src={this.getThumbnailImage(image.name.split('.').pop() ?? '', image.url)} alt={image.name} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div>{this.props.selectedImageLabel ?? MediaSelector.selectedImageLabel}</div>
                        <div>{this.state.focusedImage.name}</div>
                        <div>{this.state.focusedImage.url}</div>
                    </DialogContent>
                    <DialogFooter>
                        <ButtonBar>
                            <RightButtons>
                                <Button
                                    onClick={() => this.handleCancelModal()}
                                    styleType={'outlined'}
                                    style={{ minWidth: '120px' }}
                                >
                                    {this.props.cancelButtonLabel ?? MediaSelector.cancelButtonLabel}
                                </Button>
                                <Button
                                    disabled={this.state.focusedImage.url === ''}
                                    onClick={() => this.selectImage()}
                                    style={{ minWidth: '120px' }}
                                >
                                    {this.props.okButtonLabel ?? MediaSelector.okButtonLabel}
                                </Button>
                            </RightButtons>
                        </ButtonBar>
                    </DialogFooter>
                </Dialog>
            </div>
        )
    }

    private getThumbnailImage(fileType: string, fileUri: string): string
    {
        const imageFileTypes = ['jpeg', 'jpg', 'gif', 'png', 'svg'];
        if (imageFileTypes.includes(fileType))
        {
            return fileUri;
        }
        else if (fileType == 'css')
        {
            return "../../../images/FilePlaceholderImages/CSS.svg";
        }
        else if (fileType == 'docx')
        {
            return "../../../images/FilePlaceholderImages/DOCX.svg";
        }
        else if (fileType == 'html')
        {
            return "../../../images/FilePlaceholderImages/HTML.svg";
        }
        else if (fileType == 'json')
        {
            return "../../../images/FilePlaceholderImages/JSON.svg";
        }
        else if (fileType == 'mp4')
        {
            return "../../../images/FilePlaceholderImages/HTML.MP4";
        }
        else if (fileType == 'pdf')
        {
            return "../../../images/FilePlaceholderImages/PDF.svg";
        }
        else if (fileType == 'pptx')
        {
            return "../../../images/FilePlaceholderImages/PPTX.svg";
        }
        else if (fileType == 'pptx-1')
        {
            return "../../../images/FilePlaceholderImages/PPTX-1.svg";
        }
        else if (fileType == 'txt')
        {
            return "../../../images/FilePlaceholderImages/TXT.svg";
        }
        else if (fileType == 'xlsx')
        {
            return "../../../images/FilePlaceholderImages/XLSX.svg";
        }
        else if (fileType == 'xsl')
        {
            return "../../../images/FilePlaceholderImages/XSL.svg";
        }
        else
        {
            return "../../../images/FilePlaceholderImages/UNKNOWN.svg";
        }
    }
}

export interface IMediaSelectorProps
{
    selectButtonLabel?: string;
    dialogTitle?: string;
    duplicateImageError?: string;
    selectedImageLabel?: string;
    okButtonLabel?: string;
    cancelButtonLabel?: string;
    options: IMediaSelectorImage[];
    imageSelected: (file: { name: string, url: string }) => void;
    defaultSelectedImage: string;
    noPreview?: boolean;
    required?: boolean;
    onFileUploaded: () => {};
    uploadPath: string;
    allowedFileTypes: Accept;
}

export interface IMediaSelectorState
{
    show: boolean;
    focusedImage: IMediaSelectorImage;
    selectedImage: IMediaSelectorImage;
    selectedFile: IMediaSelectorFile;
    showFileNameExistsError: boolean;
    resetFilesToken: string;
}

export interface IMediaSelectorImage
{
    name: string;
    url: string;
}

export interface IMediaSelectorFile
{
    name: string;
    path: string;
}